<div class="sectionBlock" [formGroup]="bankForm">
  <div class="row">
    <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="form-group">
        <div class="mb-3"><strong>Account Holder Name.</strong><span class="formMandatoryInput">*</span></div>
        <input type="text" class="form-control" placeholder="Bank Account Holder Name"
          formControlName="accountHolderName">
        <div *ngIf="Submitted && f['accountHolderName'].errors" class="formMandatoryInput" style="font-size: 12px;">
          Account holder name
          is reqiured.
        </div>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="form-group">
        <div class="mb-3"><strong>Bank Account.</strong><span class="formMandatoryInput">*</span></div>
        <input type="text" class="form-control" placeholder="Bank Account No" formControlName="bankAccountNo">
        <div *ngIf="Submitted && f['bankAccountNo'].errors" class="formMandatoryInput" style="font-size: 12px;">
          Account number
          is reqiured.
        </div>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="form-group">
        <div class="mb-3"><strong>IFSC Code.</strong><span class="formMandatoryInput">*</span></div>
        <input type="text" class="form-control" style="position:absolute;" placeholder="IFSC Code"
          formControlName="ifsc">
        <i class="fa fa-search searchIcon" (click)="fetchBankDetails()"></i>
        <div *ngIf="Submitted && f['ifsc'].errors" class="formMandatoryInput" style="font-size: 12px;">IFSC code
          is reqiured.
        </div>
      </div>
    </div>

    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-3">
      <div class="form-group d-flex">
        <strong>Branch Name:</strong>
        <label>{{ this.currentBankRecord ? (' ' + this.currentBankRecord?.branchName) : (' ' + branchName)}}</label>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="form-group d-flex">
        <strong>Branch Address: </strong>
        <label>{{ this.currentBankRecord ? (' ' + this.currentBankRecord?.branchAddress) : (' ' +
          branchAddress)}}</label>
      </div>
    </div>
    <div class="col-sm-12 d-flex justify-content-end mt-3" style="gap: 10px;">
      <button type="button" class="btn btn-secondary" (click)="closeBankDialogue()">Close</button>
      <button type="submit" class="btn btn-primary dark-theme-btn" (click)="onSubmit()">Save</button>
    </div>
  </div>
</div>
<!-- </p-dialog> -->
